export default {
  auth: () => import("/app/src/layouts/auth.vue").then(m => m.default || m),
  default: () => import("/app/src/layouts/default.vue").then(m => m.default || m),
  design: () => import("/app/src/layouts/design.vue").then(m => m.default || m)
}